module.exports = __webpack_public_path__ + "static/01-TULSA-PRO_Hero-Image-41efc0d13455189c76064b4147430af9.png";